import React, { Fragment, PureComponent } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Button, ButtonToolbar, Table } from "reactstrap";

import "./styles.css";
import axios from "axios";
import _ from "lodash";
import Util from '../../Common/util';
import API from '../../Common/api';


var page_break_check_val;
var arrayValue = [];

class PrintPickingDetail extends PureComponent {
  constructor(props) {
    /*var today = new Date(),
            date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();*/

    

    var tempDate = new Date();
    var date =
      tempDate.getFullYear() +
      "-" +
      (tempDate.getMonth() + 1) +
      "-" +
      tempDate.getDate() +
      " " +
      tempDate.getHours() +
      ":" +
      tempDate.getMinutes() +
      ":" +
      tempDate.getSeconds();
    const currDate = date;
    super(props);
    this.onLogin = this.onLogin.bind(this);
    this.prinData = this.prinData.bind(this);
    this.state = {
      showPassword: false,
      showPrintData: [],
      date: currDate,
      page_break_check: false,
      arrayValue: [],
    };

    this.showPassword = this.showPassword.bind(this);
  }

  showPassword(e) {
    e.preventDefault();
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  }

  componentDidMount() {
    var printDetail_data = localStorage.getItem("printData");
     var printDetails = JSON.parse(printDetail_data);
    
    console.log("tsyyst", printDetails);

    arrayValue = printDetails;

    this.setState({
      arrayValue: printDetails
    })
    

   //return false;


    setTimeout(this.prinData, 1100);

    /*if (window.location.href="/putaway/printPutaway") {
          window.location.reload();
        }*/
  }

  prinData() {
    /* for (var i = 0; i < this.state.printDetails.length; i++) {*/
    window.print();

    /*}*/
  }

  onLogin() {
    const payload = {
    
    };
  
  API.post('/auth/oauth2/login', { param: payload })
   
      .then((response) => {
        console.log(response.data.login);
        if (response.data.login === false) {
          window.location.href = response.data.url;
        }
      })
      .catch(function (error) {});
  }

  render() {
    const { handleSubmit } = this.props;
    
  

    const ptlText = "Party Packing Loose Picking Sheet"
    const manualText = "Party Packing CLD Picking Sheet"
   
   
    
    
    var userIndex = 0;
  var itemLen = 0;
  var zoneNameArr = []
    return (
      <div style={{borderLeftWidth: 0}} className="print_table">
        {/*<table className="no_border_table" style={{borderWidth: 0, backgroundColor: '#fff', marginBottom: 0, width: '90%', margin: 'auto', marginTop: 30}}
        >
            <thead className="table_background"
              style={{ background: "#fff" }}
            >
              <tr style={{ marginTop: 20, background: "#fff" }}>
                <th style={{textAlign: 'center'}} colspan="12">ysuysiusi</th>

                
               </tr>
            </thead>
        </table>  */}

       
      
          
        
            <div style={{ width: "95%", margin: 'auto' ,paddingBottom:0}}>
       
              <div
                
              >
               
        
                  
                  <div>
                  <table style={{width: '100%', padding: 15, borderWidth: 0}}
                    responsive
                    
                  >
                    <thead
                      className="thead_align table_background"
                      style={{ background: "#fff" }}
                    >


                      <tr style={{ marginTop: 20, background: "#fff" }}>
                        <th colspan="2" style={{ marginTop: 20 }}>
                          <h5>
                            {" "}
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              PO Number:{" "}
                            </span>{" "}
                            <span> {this.state.arrayValue.length > 0 ? this.state.arrayValue[0].po_number: ""} </span>{" "}
                          </h5>
                        </th>
                       
                         <th colspan="1" style={{ marginTop: 20 }}>
                          <h5>
                            {" "}
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              PO Type:{" "}
                            </span>{" "}
                            <span> { this.state.arrayValue.length > 0 ?this.state.arrayValue[0].po_type : ""}</span>{" "}
                          </h5>
                        </th>
                       
                        <th colspan="2" style={{ marginTop: 20 }}>
                          <h5>
                            {" "}
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              PO Date:{" "}
                            </span>{" "}
                            <span> {this.state.arrayValue.length > 0 ? this.state.arrayValue[0].po_date : ""}</span>{" "}
                          </h5>
                        </th>
                        
                         <th colspan="2" style={{ marginTop: 20 }}>
                          <h5>
                            {" "}
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              Brand:{" "}
                            </span>{" "}
                            <span> {this.state.arrayValue.length > 0 ? this.state.arrayValue[0].brand : ""}</span>{" "}
                          </h5>
                        </th>

                        <th colspan="2" style={{ marginTop: 20 }}>
                          <h5>
                            {" "}
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              Assigned User:{" "}
                            </span>{" "}
                            <span> { this.state.arrayValue.length > 0 ?this.state.arrayValue[0].assigned_user :""}</span>{" "}
                          </h5>
                        </th>

                      </tr>

                      

                      <tr className="border-thead border_head border_thead" style={{ marginTop: 20 }}>
                         <th style={{ marginTop: 20 }}>Sr No.</th> 
                          <th style={{ marginTop: 20 }}>Location </th>
                        <th style={{ marginTop: 20 }}>Prod Code </th>
                        <th style={{ marginTop: 20 }}> Prod Desc </th>
                         <th style={{ marginTop: 20 }}> UPC </th>
                         <th style={{ marginTop: 20 }}> MRP </th>
                        <th style={{ marginTop: 20 }}>PKD </th>
                       
                        <th style={{ marginTop: 20 }}> Cases / CLD Qty </th>
                        <th style={{ marginTop: 20 }}>Loose Qty </th>
                        <th style={{ marginTop: 20 }}>Received Qty</th>

                       
                      </tr>
                    </thead>
                    <tbody>
                      {              
                     
                          this.state.arrayValue.map((insideItem, index) => {
                            return (
                              <tr className="tbody_align"
                          
                        >
            
                          <td> {index+1}</td>
                          <td> {insideItem.sorting_bin__bin_address}</td>
                          <td> {insideItem.product__sku7_code}</td>
                              <td> {insideItem.product__lb_sku_product_name} </td>
                              <td> {insideItem.product__upc} </td>
                              <td> {insideItem.product__mrp} </td>
                              <td> {insideItem.pkd} </td>
                              
                              <td> {insideItem.calc_inner_qty} </td>
                              <td> {insideItem.calc_each_qty} </td>
                              <td> </td>
                              

                             
                        </tr>
                            );
                          })
                      }
                      
                    </tbody>
          
                  </table>
                  <div>
                  </div>

                
                  
                  
                    
                  
                  </div>

     
        
              </div>
              
            </div>


      </div>
    );
  }
}

export default PrintPickingDetail;
